
import { Component, Prop, Vue } from 'vue-property-decorator'

import NequiModel from '../models/Nequi'

import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EPaymentInfo,
  },
})
export default class Nequi extends Vue {
  @Prop({ required: true }) readonly nequi!: NequiModel
}
